import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Editors, Filters, Formatters} from 'angular-slickgrid';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit, OnDestroy {

    attrSelected: number;
    areaSelected: number;
    parentSelected: number;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    parents = [];
    parentName: string;
    attrVal: string;
    attrDesc: string;
    sequence: number;

    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private baseFlag: any;
    isChecked = false;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private userAuth: Subscription;
    private adminAuth: Subscription;
    offset: number;
    isCommandRequired = false;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    statusSelected: any;
    status: any;
    des: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;




    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (this.baseFlag) {
                        if (!this.edit) {
                            this.notifier.notify('error', 'You do not have edit permission');
                        } else {
                            this.editItem(item);
                        }
                    } else {
                        if (!this.messageService.edit) {
                            this.notifier.notify('error', 'You do not have edit permission');
                        } else {
                            this.editItem(item);
                        }
                    }
                    break;
                case 'delete':
                    if (this.baseFlag) {
                        if (!this.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            this.deleteItem(item);
                        }
                    } else {
                        if (!this.messageService.del) {
                            this.notifier.notify('error', 'You do not have delete permission');
                        } else {
                            this.deleteItem(item);
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            }
        });
    }

    deleteItem(item) {
        if (confirm('Are you sure?')) {
            this._rest.deleteTicketAttributesClientWise({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // this.totalData = this.totalData - 1;
                    // this.messageService.setTotalData(this.totalData);
                    this.messageService.sendAfterDelete(item.id);
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
            });
        }
    }

    editItem(item) {
        item.user_id = this.messageService.getUserId();
        item.clientId = this.clientId;
        this._rest.updateTicketCategory(item).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.notifier.notify('success', 'Updated successfully');
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';

        this.displayData = {
            pageName: 'Maintain Status',
            openModalButton: 'Add Status',
            searchModalButton: 'Search',
            breadcrumb: 'Status',
            folderName: 'All Status',
            tabName: 'Status',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 40, filterable: true},
            {
                id: 'user', name: 'Name', field: 'name', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'Description',
                name: 'Description',
                field: 'description',
                sortable: true,
                filterable: true,
                cssClass: 'highlight',
                editor: {
                    model: CustomInputEditor,
                }
            }, {
                id: 'sequence', name: 'Sequence ', field: 'seq', sortable: true, filterable: true
            }, {
                id: 'stopSlaMeter',
                name: 'Stop SLA Meter ',
                field: 'stopSlaMeter',
                sortable: true,
                filterable: true,
                formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                },
                cssClass: 'highlight',
                editor: {model: Editors.checkbox}
            }, {
                id: 'commentRequired',
                name: 'Comment Required',
                field: 'commandRequired',
                sortable: true,
                filterable: true,
                // formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: 'Y', label: 'Y'}, {value: 'N', label: 'N'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllStatus(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }
    

    openModal(content) {
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.attrSelected = 0;
                this.areaSelected = 0;
                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {
                });
            }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.attrSelected = 0;
                this.areaSelected = 0;
                this.modalService.open(content, {size: 'sm'}).result.then((result) => {
                }, (reason) => {
                });
            }
        }
    }


    searchModal() {
        if (this.baseFlag) {
            if (!this.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.attrSelected = 0;
                this.areaSelected = 0;
                this.statusSelected = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
                }
        } else {
            if (!this.messageService.add) {
                this.notifier.notify('error', 'You do not have add permission');
            } else {
                this.isError = false;
                this.attrSelected = 0;
                this.areaSelected = 0;
                this.statusSelected = '';
                this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
                }
        }
    }


    search() {
        this._rest.searchAllStatus(this.statusSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.status = this.respObject.details;
                this.messageService.setTotalData(this.status.length);
                this.messageService.setGridData(this.status);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    save() {
        let isCommend;
        if (this.isCommandRequired) {
            isCommend = 'Y';
        } else {
            isCommend = 'N';
        }
        const arrayStatus = [];
        const status = {
            description: this.attrDesc,
            name: this.attrVal,
            seq: this.sequence,
            stopSlaMeter: String(this.isChecked),
            commandRequired: isCommend,
        };
        arrayStatus.push(status);
        const data = {
            clientId: this.clientId,
            attrId: 2,
            arrayStatus: arrayStatus,
            createdBy: this.messageService.getUserId()
        };

        if (!this.messageService.isBlankField(data)) {
            this._rest.insertTicketAttributesClientWise(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.sequence = 0;
                    this.attrDesc = '';
                    this.attrVal = '';
                    this.isCommandRequired = false;
                    this.isChecked = false;
                    // this.getParent();
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (this.baseFlag) {
            if (!this.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        } else {
            if (!this.messageService.view) {
                this.notifier.notify('error', 'You do not have view permission');
            } else {
                this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
            }
        }
    }

    getNewTableData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getSomeStatus(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            // console.log('==================' + JSON.stringify(this.respObject));
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getNewTableData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onParentChange(selectedIndex: any) {
        this.parentName = this.parents[selectedIndex].name;
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

}
